import { CallAPI } from "../../apiManager/ApiCall";
import {
  quizTranslateTitleURL,
  quizTranslateQuestionURL,
} from "../../apiManager/APIConfig";

/**
 * Trigger AI translation of an entire quiz title — including the title
 * text itself AND every question that belongs to it — into every
 * supported app language. **Re-running OVERWRITES existing
 * translations** (UPSERT semantics on the backend), so this button
 * doubles as a "refresh translations" action.
 *
 * Resolves to the raw backend payload:
 *   {
 *     status, message, appLangs,
 *     titleSourceLang, titleTargetLangs, titleResults: [{lang, action}],
 *     questionCount, questionsTranslated, questionsFailed,
 *     questionResults: [{ quizId, sourceLang?, targetLangs?, results?, error? }]
 *   }
 */
export const translateQuizTitleCall = async (titleId) => {
  if (!titleId) return { status: 400, message: "Missing title id." };
  return CallAPI({
    url: quizTranslateTitleURL,
    method: "POST",
    body: { quiz_title_id: titleId },
  });
};

/**
 * Trigger AI translation of ONE question into every supported app
 * language (except its own source). **UPSERT** — re-running overwrites
 * any existing translation rows for the question.
 *
 * Resolves to:
 *   {
 *     status, message, appLangs,
 *     quizId, sourceLang, targetLangs,
 *     results: [{lang, action: "created"|"updated"}],
 *     created, updated
 *   }
 */
export const translateQuizQuestionCall = async (quizId) => {
  if (!quizId) return { status: 400, message: "Missing quiz id." };
  return CallAPI({
    url: quizTranslateQuestionURL,
    method: "POST",
    body: { quiz_id: quizId },
  });
};
